import React from "react";
import { cn } from "utils";
import { ContentNavigationMenuProps } from "./types";
import Translations from "@translate/components/Chat/ContentNavigationMenu/ContentNavigationMenu";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

const SkeletonItem = () => (
  <div
    className={cn("flex items-center px-5 py-2 border-l-2 border-transparent")}
  >
    <div className="flex-1">
      <div className={cn("h-5 bg-content_primary/5 rounded animate-pulse")} />
    </div>
  </div>
);

export const ContentNavigationMenu: React.FC<ContentNavigationMenuProps> = ({
  title = I18n.t("Content"),
  menuItems,
  activeItemId,
  onItemClick,
  className = "",
  isLoading = false,
}) => {
  if (!isLoading && menuItems.length === 0) {
    return null;
  }
  return (
    <div
      className={cn(
        "flex flex-col",
        "border border-solid border-border_white_transparent10",
        "rounded-2",
        "pb-3",
        "overflow-auto hide-scrollbar max-h-[480px]",
        className,
      )}
    >
      {/* Header */}
      <div
        className={cn(
          "flex items-center justify-center top-0 sticky bg-background_solid_secondary",
          "px-4 pt-3 pb-2",
        )}
      >
        <div className={cn("flex-1", "title_l", "text-content_primary")}>
          {title}
        </div>
      </div>

      {/* Menu Items */}
      <div className="flex flex-col pt-2">
        {isLoading
          ? Array.from({ length: 5 }).map((_, index) => (
              <SkeletonItem key={index} />
            ))
          : menuItems.map((item) => {
              const isActive = activeItemId
                ? item.id === activeItemId
                : item.isActive || false;

              return (
                <div
                  data-openreplay-label="ContentNavigationMenu · ContentNavigationMenu · div"
                  key={item.id}
                  className={cn(
                    "flex items-center",
                    "px-5 py-2",
                    "cursor-pointer",
                    "transition-all duration-200",
                    isActive
                      ? "border-l-2 border-solid border-border_brand_solid"
                      : "border-l-2 border-transparent",
                  )}
                  onClick={() => onItemClick?.(item.id)}
                >
                  <div
                    className={cn(
                      "flex-1",
                      "title_m",
                      "overflow-hidden",
                      "line-clamp-2",
                      isActive
                        ? "text-content_brand_primary"
                        : "text-content_secondary hover:text-content_primary",
                    )}
                  >
                    {item.label}
                  </div>
                </div>
              );
            })}
      </div>
    </div>
  );
};
